

import { swatch, fileIcon, ai, home } from "../../../assets/editor";



export const transformLogoDefault = {
    // Sección 0: Animación
    "section-0": {
        rotationZ: 0,
        positionX: -2000,
        extrusion_depth: 3,
        durationExtrusion: 0.5,

    },
};

export const transformLogo = {
    // Sección 0: Animación
    "section-0": {
        rotationZ: 0,
        positionX: 0,
        positionY: 0,
        extrusion_depth: 3,

    },
    // Sección 1: Bienvenida
    "section-1": {
        // rotationZ: -0.45,
        rotationX: -0,
        rotationY: -0.4,
        rotationZ: -0,
        positionX: 130,
        extrusion_depth: 22,
        durationExtrusion: 5.5,
    },
    // Sección 2: Sección de Features
    "section-2": {
        // rotationZ: 0.45,
        positionX: 120,
        positionY: 420,
        positionZ: -2120,
        extrusion_depth: 40,
        durationRotation: 0.5,
        durationPosition: 0.5,
    },
    // Sección 3: Diseño Personalizado
    "section-3": {
        rotationZ: -0.1,
        rotationY: 0.4,
        positionX: -130,
        positionY: -0,
        positionZ: -50,
        extrusion_depth: 22,
        durationPosition: 0.5,

    },
    // Sección 4: ¿Por qué elegirnos?
    "section-4": {
        rotationZ: 0.08,
        rotationY: -0.4,
        positionX: 130,
        extrusion_depth: 22,
    },
    // Sección 5: ¿Cómo funciona?
    "section-5": {
        rotationZ: -0.05,
        rotationY: 0.4,
        positionX: -130,
        extrusion_depth: 20,
    },
    // Sección 6: Botón Continuar
    "section-6": {
        positionX: -125,
        positionZ: 120,
        rotationZ: 0,
        rotationY: 0,
        extrusion_depth: 0.2,
    },
};




// Transformaciones Responsivas para Mobile
export const transformLogoHomeMobile = {
    "section-0": {
        rotationX: 0,
        rotationY: 0,
        rotationZ: 0,
        positionX: 0,
        positionY: 0,
        positionZ: 170,
        extrusion_depth: 150, // Reducido
        durationExtrusion: 5.0, // Ajustado
        durationPosition: 3.5, // Ajustado

    },
    "section-1": {
        rotationX: -0.34,
        rotationY: 0, // Reducido
        rotationZ: 0,
        positionX: 0, // Reducido
        positionY: 75, // Reducido
        positionZ: 70,
        extrusion_depth: 75, // Reducido
        durationExtrusion: 4.0, // Ajustado
        durationRotation: 2.9
    },
    "section-2": {
        positionX: 80, // Reducido
        positionY: 250, // Reducido
        positionZ: -2500, // Reducido
        extrusion_depth: 25, // Reducido
        durationRotation: 0.5,
        durationPosition: 0.5,
    },
    "section-3": {
        rotationZ: 0, // Reducido
        rotationY: 0, // Reducido
        positionX: 0, // Reducido
        positionY: 60,
        positionZ: 130, // Reducido
        extrusion_depth: 43, // Reducido
        durationPosition: 0.5,
    },
    "section-4": {
        rotationZ: 0.04, // Reducido
        rotationY: -0.2, // Reducido
        positionX: 0, // Reducido
        positionY: 70, // Reducido
        positionZ: 90,
        durationExtrusion: 2.5,
        extrusion_depth: 35, // Reducido
    },
    "section-5": {
        // rotationZ: -0.025, // Reducido
        rotationX: -0.45, // Reducido
        rotationY: 0, // Reducido
        rotationZ: 3.14*4, // Reducido
        positionX: 0, // Reducido
        positionY: 48, // Reducido
        positionZ: 120, // Reducido
        extrusion_depth: 150, // Reducido
        durationExtrusion: 5.5,

        durationPosition: 1.5,
    },
    "section-6": {
        positionX: 0, // Reducido
        positionY: 45,
        positionZ: 166, // Reducido
        rotationZ: 0,
        rotationY: 0,
        extrusion_depth: 120, // Reducido
        durationPosition: 1.5,
        durationExtrusion: 5.5,


    },
    "section-7": {
        positionX: 80,
        positionY: 250,
        positionZ: -2500,
        extrusion_depth: 25,
        durationRotation: 0.5,
        durationPosition: 0.5,
    },
};

// Transformaciones Responsivas para Tablet
export const transformLogoHomeTablet = {
    "section-0": {
        rotationZ: 0,
        positionX: 0,
        positionY: 0,
        positionZ: 150,
        durationPosition: 0.5,
        extrusion_depth: 2.5, // Intermedio

    },
    "section-1": {
        rotationX: 0,
        rotationY: -0.3, // Intermedio
        rotationZ: 0,
        positionX: 115, // Intermedio
        extrusion_depth: 18, // Intermedio
        durationExtrusion: 4.75, // Ajustado
    },
    "section-2": {
        positionX: 100, // Intermedio
        positionY: 330, // Intermedio
        positionZ: -1800, // Intermedio
        extrusion_depth: 32, // Intermedio
        durationRotation: 0.5,
        durationPosition: 0.5,
    },
    "section-3": {
        rotationZ: -0.075, // Intermedio
        rotationY: 0.3, // Intermedio
        positionX: -115, // Intermedio
        positionY: 0,
        positionZ: -40, // Intermedio
        extrusion_depth: 18, // Intermedio
        durationPosition: 0.5,
    },
    "section-4": {
        rotationZ: 0.06, // Intermedio
        rotationY: -0.33, // Intermedio
        positionX: 112, // Intermedio
        extrusion_depth: 38, // Intermedio
        durationExtrusion: 4.75, // Ajustado
    },
    "section-5": {
        rotationZ: -0.0375, // Intermedio
        rotationY: 0.3, // Intermedio
        positionX: -100, // Intermedio
        extrusion_depth: 18, // Intermedio
    },
    "section-6": {
        positionX: 130, // Intermedio
        positionZ: 20, // Intermedio
        rotationZ: 0,
        rotationY: -0.40,
        extrusion_depth: 0.15, // Intermedio
    },
    "section-7": {
        positionX: 100,
        positionY: 330,
        positionZ: -1800,
        extrusion_depth: 32,
        durationRotation: 0.5,
        durationPosition: 0.5,
    },
};

// Transformaciones Responsivas para Desktop
export const transformLogoHomeDesktop = {
    "section-0": {
        rotationZ: 0,
        positionX: 0,
        positionZ: 20,
        positionY: 0,
        extrusion_depth: 32, // Original
        durationExtrusion: 5.5, // Original

    },
    "section-1": {
        rotationX: 0,
        rotationY: -0.4, // Original
        rotationZ: 0,
        positionX: 170, // Original
        positionY: 0, // Original
        positionZ: -110, // Original
        extrusion_depth: 12, // Original
        durationExtrusion: 2.5, // Original
    },
    "section-2": {
        positionX: 120, // Original
        positionY: 420, // Original
        positionZ: -2120, // Original
        extrusion_depth: 40, // Original
        durationRotation: 0.5,
        durationPosition: 0.5,
    },
    "section-3": {


        positionX: -175, // Original
        positionY: 0,
        positionZ: -100, // Original
        rotationX: 0,
        rotationY: 3.14/8,
        rotationZ: 0,
        extrusion_depth: 22, // Original
        durationPosition: 0.5,
    },
    "section-4": {
        rotationZ: 0.08, // Original
        rotationY: -0.4, // Original
        positionX: 160, // Original
        positionZ: -110, // Original
        extrusion_depth: 22, // Original
    },
    "section-5": {
        rotationZ: -0.05, // Original
        rotationY: 0.4, // Original
        positionX: -160, // Original
        extrusion_depth: 20, // Original
    },
    "section-6": {
        positionX: 175, // Original
        positionY: -12, // Original
        positionZ: -20, // Original
        rotationZ: 0,
        rotationY: 0,
        extrusion_depth: 0.2, // Original
    },
    "section-7": {
        positionX: 120,
        positionY: 420,
        positionZ: -2120,
        extrusion_depth: 40,
        durationRotation: 0.5,
        durationPosition: 0.5,
    },
};

export const transformLogoAbout = {
    "section-0": {
        positionX: 150,
        positionY: 0,
        positionZ: -30,
        rotationX: 0.1,
        rotationY: 1.52,   // ≈ 87° — vista de canto, extrusion visible como línea gruesa
        rotationZ: 0,
        extrusion_depth: 3,
        durationExtrusion: 1.2,
        durationRotation: 1.5,
        durationPosition: 1.5,
    },
}




export const transformLogoAboutMobile = {
    "section-0": {
        positionX: 0,
        positionY: 90,
        positionZ: 120,
        rotationX: 0.1,
        rotationY: 1.52,   // ≈ 87° — vista de canto, extrusion visible como línea gruesa
        rotationZ: 0,
        extrusion_depth: 3,
        durationExtrusion: 1.2,
        durationRotation: 1.5,
        durationPosition: 1.5,
    },
}
export const transformLogoAboutTablet = {
    "section-0": {
        positionX: 150,
            positionY: 0,
            positionZ: -30,
            rotationX: 0.1,
            rotationY: 1.52,   // ≈ 87° — vista de canto, extrusion visible como línea gruesa
            rotationZ: 0,
            extrusion_depth: 3,
            durationExtrusion: 1.2,
            durationRotation: 1.5,
            durationPosition: 1.5,
    },
}
export const transformLogoAboutDesktop = {
    "section-0": {
        positionX: 150,
            positionY: 0,
            positionZ: -30,
            rotationX: 0.1,
            rotationY: 1.52,   // ≈ 87° — vista de canto, extrusion visible como línea gruesa
            rotationZ: 0,
            extrusion_depth: 3,
            durationExtrusion: 1.2,
            durationRotation: 1.5,
            durationPosition: 1.5,
    },
}





export const transformLogoContact = {
    "section-0": {
        positionX: -120,
        positionY: 0,
        positionZ: 0,
        rotationX: 0,
        rotationY: 0,
        rotationZ: 0,
        extrusion_depth: 3,

    },
}




export const transformLogoContactMobile = {
    "section-0": {
        positionX: 0,
        positionY: -120,
        positionZ: 0,
        rotationX: 0,
        rotationY: 0,
        rotationZ: 0,
        extrusion_depth: 5,   // Punto de partida: pocas capas (crece con scroll hasta maxExtrusion)
        maxExtrusion: 130,    // Tope de extrusión al llegar al final del scroll
    },
};

export const transformLogoContactTablet = {
    "section-0": {
        positionX: -110,
        positionY: 0,
        positionZ: -10,
        rotationX: -0.4,
        rotationY: -0.1,
        rotationZ: 0,
        extrusion_depth: 22,
        maxExtrusion: 90,
    },
};

export const transformLogoContactDesktop = {
    "section-0": {
        // Logo plano visto desde arriba (base perpendicular a cámara)
        // rotationX = π/2 → extrusión crece en Y (hacia cámara) = capas de impresión 3D
        positionX: 170,   // centrado en el panel derecho (aside ocupa ~48% viewport)
        positionY: -50,
        positionZ: -10,
        rotationX: Math.PI / 2,  // 90° exactos — vista cenital perfecta
        rotationY: 0.00,
        rotationZ: 0.000,
        extrusion_depth: 2,
        maxExtrusion: 90,
        durationExtrusion: 0.8,
        durationRotation: 1.8,
        durationPosition: 1.8,
    },
};

export const transformLogoLoginMobileLandscape = {
    "section-0": {
        positionX: -150,
        positionY: 0,
        positionZ: 0,
        rotationX: 0,
        rotationY: 1/4,
        rotationZ: 0,
        extrusion_depth: 130, // Menor profundidad para pantallas pequeñas
    },
};

export const transformLogoLoginMobile = {
    "section-0": {
        positionX: 0,
        positionY: -70,
        positionZ: 85,
        rotationX: -0.32,
        rotationY: 0,
        rotationZ: 0,
        extrusion_depth: 130, // Menor profundidad para pantallas pequeñas
    },
};

export const transformLogoLoginTablet = {
    "section-0": {
        positionX: -110,
        positionY: 0,
        positionZ: -10,
        rotationX: 0,
        rotationY: 0.2,
        rotationZ: 0,
        extrusion_depth: 122, // Ajuste moderado para tablets
        durationExtrusion: 0.5,
    },
};

export const transformLogoLoginDesktop = {
    "section-0": {
        positionX: -156,
        positionY: 0,
        positionZ: -20,
        rotationX: 0.2,
        rotationY: 0.2,
        rotationZ: 0.1,
        extrusion_depth: 12, // Configuración completa para pantallas grandes
    },
};































export const transition = { type: "spring", duration: 0.8 };

// Salidas rápidas: un spring de 0.8s al desmontar se percibe lento;
// las salidas deben ser más cortas que las entradas.
export const exitTransition = { type: "tween", duration: 0.2, ease: "easeIn" };


export const fadeAnimation = {
    initial: {
        opacity: 0,
        transition: { ...transition, delay: 0.5 },
    },
    animate: {
        opacity: 1,
        transition: { ...transition, delay: 0 },
    },
    exit: {
        opacity: 0,
        transition: { ...exitTransition, delay: 0 },
    },
};

export const slideAnimation = (direction) => {
    return {
        initial: {
            x: direction === "left" ? -100 : direction === "right" ? 100 : 0,
            y: direction === "up" ? 100 : direction === "down" ? -100 : 0,
            opacity: 0,
            transition: { ...transition, delay: 0.5 },
        },
        animate: {
            x: 0,
            y: 0,
            opacity: 1,
            transition: { ...transition, delay: 0 },
        },
        exit: {
            x: direction === "left" ? -100 : direction === "right" ? 100 : 0,
            y: direction === "up" ? 100 : direction === "down" ? -100 : 0,
            opacity: 0,
            transition: { ...exitTransition, delay: 0 },
        },
    };
};


export const slideAnimation2 = () => {
    return {
        initial:{ opacity: 0, width: "0%" },
        animate:{ opacity: 1, width: "100%" },
        // exit:{ opacity: 0, x: 50 },
        transition:{ duration: 0.3, delay: 0.1 },
    }
}
export const slideAnimation3 = () => {
    return {
        initial:{ opacity: 0, width: "0%" },
        animate:{ opacity: 1, width: "100%" },
        // exit:{ opacity: 0, x: 50 },
        transition:{ duration: 0.3, delay: 0.3},
    }
}

export const slideAnimation4 = () => {
    return {
        initial:{ opacity: 0, width: "0%" },
        animate:{ opacity: 1, width: "100%" },
        // exit:{ opacity: 0, x: 50 },
        transition:{ duration: 0.3, delay: 0.3},
    }
}

export const slideAnimation5 = () => {
    return {
        initial:{ opacity: 0, x: 50 },
        animate:{ opacity: 1, x: 0 },
        exit:{ opacity: 0, x: 50 },
        transition:{ duration: 0.3, delay: 0.1 },
    }
}

export const EditorTabs = [
    {
        name: "colorpicker",
        icon: swatch,
    },
    {
        name: "filepicker",
        icon: fileIcon,
    },
    {
        name: "aipicker",
        icon: ai,
    },
    {
        name: "homeCamera",
        icon:  home,
    },
];
